import { observer } from 'mobx-react-lite'
import PoweredBy from 'shared/assets/images/billing/PoweredBy.svg'
import { Divider, Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const SecurePaymentInfo = observer(() => (
  <div className={styles.cardWrapper}>
    <div className={styles.cardRightLabel}>
      <Icon icon={'lock'} color={'var(--green-70)'} fontSize={16} />
      <Typography ariaLabel={'cardRightLabel'} variant={'body-sm-regular'}>
        Safe & Secure Checkout
      </Typography>
      <img src={PoweredBy} alt='poweredBy' className={styles.cardImage} />
    </div>
    <Divider
      style={{
        width: '100%',
        margin: '10px 0 8px',
        borderColor: 'var(--black-20)',
      }}
    />
    <div className={styles.cardIcons}>
      <Icon icon={'visa'} fontSize={26} />
      <Icon icon={'mastercard'} fontSize={26} />
      <Icon icon={'americanExpress'} fontSize={26} />
      <Icon icon={'JCB'} fontSize={26} />
      <Icon icon={'discover'} fontSize={26} />
      <Icon icon={'dinersClub'} fontSize={26} />
      <Icon icon={'unionPay'} fontSize={26} />
    </div>
  </div>
))
